<template>
  <PurpleHexContainer class="pt-12 sm:pt-4 text-white">
    <div
      class="
        splash-testimonial__inner
        grid
        items-center
        mx-auto
        max-w-5xl
        pr-6
        pl-10
        sm:pl-16
        xl:p-0
      "
    >
      <p
        class="
          splash-testimonial__quote
          font-body-large font-bold
          md:font-display-mega
          relative
          col-span-full
          sm:col-span-1
          lg:self-end
        "
      >
        As a small business, Bambee was exactly what we needed for HR.
        Affordable, professional, and friendly! We absolutely recommend them.
      </p>
      <div class="sm:self-start sm:row-start-2 text-right">
        <b class="font-body-text font-bold">Bryan Kelly</b>
        <div class="font-body-small opacity-70">
          Owner & Vice President HOODZ Cleaning
        </div>
      </div>
      <picture class="self-end sm:row-span-2">
        <source
          srcset="
            ~/assets/images/splash/bryan-kelly.webp,
            ~/assets/images/splash/bryan-kelly-2x.webp 2x
          "
          media="(min-width: 640px)"
          type="image/webp"
        />
        <source
          srcset="~/assets/images/splash/bryan-kelly.png"
          media="(min-width: 640px)"
          type="image/png"
        />
        <source
          srcset="
            ~/assets/images/splash/bryan-kelly-sm.webp,
            ~/assets/images/splash/bryan-kelly-sm-2x.webp 2x
          "
          media="(max-width: 639px)"
          type="image/webp"
        />
        <img
          src="~/assets/images/splash/bryan-kelly-sm.png"
          load="lazy"
          class="block"
          alt=""
        />
      </picture>
    </div>
  </PurpleHexContainer>
</template>

<script>
import PurpleHexContainer from '@/components/PurpleHexContainer';

export default {
  components: { PurpleHexContainer },
};
</script>

<style scoped>
.splash-testimonial__inner {
  grid-template-columns: 1fr auto;
}

.splash-testimonial__quote::after {
  @apply absolute font-bold leading-none opacity-10 -left-11 -top-8;

  content: '“';
  font-size: 140px;
}
</style>
